export default __webpack_public_path__ + "static/media/elders-hover.63f9d01a.svg";